import { Tag } from '@doda/common/src/components/Head/metaTag';
import { MetaText } from '@doda/common/src/logics/metaTag';
import { getOgpForJobSearchList } from '@doda/common/src/logics/ogp';
import { canonicalUrlSelector } from '@doda/common/src/redux/features/canonical';
import { queryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { FC } from 'react';
import { useAppSelector } from 'redux/hooks';
import { totalJobCountSelector } from 'redux/features/jobList';

/**
 * MetaTagのprops
 */
interface Props {
  metaTagData: MetaText;
}

export const MetaTag: FC<Props> = ({ metaTagData }) => {
  const query = useAppSelector(queryParamsSelector);
  const canonicalUrl = useAppSelector(canonicalUrlSelector) || '';
  const ogp = getOgpForJobSearchList(canonicalUrl, query);
  const totalJobCount = useAppSelector(totalJobCountSelector);

  return (
    <Tag
      title={metaTagData.title}
      description={metaTagData.description}
      keywords={metaTagData.keywords}
      type={ogp.type}
      url={ogp.url}
      image={ogp.image}
      siteName={ogp.siteName}
      canonical={totalJobCount > 1 ? canonicalUrl : undefined}
      robots={metaTagData.robots ?? undefined}
    />
  );
};
